module.exports = __webpack_public_path__ + "img/bottom-image.6690eddb.jpg";